export function eventDetail() {
    $.fn.extend({
        toggleText: function (a, b) {
            return this.text(this.text() == b ? a : b);
        }
    });
    
    $('.show-more-button').click(function () {
        $(this).parents('.content-holder').toggleClass('passive');
        $(this).toggleText('Show more', 'Show less');
    });
};


// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/eventDetail.js